import instance from "../../utils/axios";

const API_BASE_URL = "/churches/team";

// ✅ Fetch Team Members
export const fetchTeam = async (_id) => {
  const formData = new URLSearchParams();
  if (_id) formData.append("_id", _id);

  const response = await instance.post(`${API_BASE_URL}/read`, formData);
  return response.data;
};

// ✅ Save Team Member
export const saveTeam = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v || ""));

  const response = await instance.post(`${API_BASE_URL}/save`, formData);
  return response.data; // { type, message, memberObjId, data }
};

// ✅ Update Team Member
export const updateTeam = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v || ""));

  const response = await instance.post(`${API_BASE_URL}/update`, formData);
  return response.data;
};

// ✅ Delete Team Member
export const deleteTeam = async (payload) => {
  const formData = new URLSearchParams();
  formData.append("_id", payload._id || "");
  formData.append("memberObjId", payload.memberObjId || "");

  const response = await instance.post(`${API_BASE_URL}/delete`, formData);
  return response.data;
};
